import { Box, Button, CircularProgress, IconButton, Sheet, Typography } from "@mui/joy";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import React from "react";
import BuildingDialog from "../Dialogs/BuildingDialog";
import { Building } from "../Pages/BuildingList";
import { useRole, isAdminRole } from "../Contexts/RoleContext";

interface BuildingHeaderProps {
	buildingId: string;
}
export default function BuildingHeader(props: BuildingHeaderProps) {
	const [bld, setBld] = React.useState<Building>();
	React.useEffect(() => getData(), [props.buildingId]);
	const [open, setOpen] = React.useState(false);
	const { effectiveRole } = useRole();

	const getData = () => {
		fetch("/Building/GetBuildingData", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setBld({ ID: x.buildings_id, Active: x.is_active, Name: x.building_name, Address1: x.address1, Address2: x.address2, PrimaryContact: x.primary_contact, City: x.city, Zip: x.zip, State: x.state, Latitude: x.latitude, Longitude: x.longitude } as Building));
	};

	const hasCoordinates = bld?.Latitude != null && bld?.Longitude != null;
	const mapsUrl = hasCoordinates ? `https://www.google.com/maps?q=${bld!.Latitude},${bld!.Longitude}` : undefined;

	return (
		<Sheet sx={{ display: "flex", p: 1.5, justifyContent: bld ? "normal" : "center", mb: 1, flexDirection: "column", gap: 1, borderRadius: 0, width: "100%" }} variant="outlined">
			{!bld && <CircularProgress />}
			{bld && (
				<>
					<BuildingDialog
						open={open}
						bld={bld}
						onUpdated={getData}
						close={() => {
							setOpen(false);
							getData();
						}}
					/>
					<Typography level="h3">
						{bld.Name}{" "}
						{isAdminRole(effectiveRole) && (
							<Button sx={{ ml: 1 }} onClick={() => setOpen(true)}>
								Edit Building
							</Button>
						)}
					</Typography>

					<Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
						{hasCoordinates ? (
							<IconButton component="a" href={mapsUrl} target="_blank" rel="noopener noreferrer" variant="plain" size="sm" title="View on map">
								<LocationOnIcon />
							</IconButton>
						) : (
							<LocationOnIcon sx={{ color: "text.tertiary", fontSize: 20 }} />
						)}
						<Typography level="body-sm">
							Primary Contact: {bld.PrimaryContact || "—"}
						</Typography>
					</Box>
				</>
			)}
		</Sheet>
	);
}

